/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The action type of the custom modal

Values: 0=GetInTouch, 1=Link, 2=GetInTouchGeneral
 * @export
 * @enum {number}
 */

export enum CustomModalActionType {
    GetInTouch = 0,
    Link = 1,
    GetInTouchGeneral = 2
}


